import { Box, Button, Container, Typography } from '@mui/material';
import PageMeta from '../components/PageMeta';

export default function Contact() {
  return (
    <Container maxWidth="sm">
      <PageMeta
        title="Contact | Anime Opening Quiz"
        description="Contact Anime Opening Quiz."
        path="/contact"
        index={false}
      />
      <Box component="main" sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1">Contact</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Contact us for anything here.
        </Typography>
        <Button component="a" href="mailto:mediumfungames@gmail.com" variant="contained">
          Open email
        </Button>
      </Box>
    </Container>
  );
}
